import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Lock } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { ContractVendorsTab } from "@/components/console/ContractVendorsTab";

/** Contract Vendors for staff granted 'Manage contract vendors' (the Users page itself is Super Admin only). */
export default function ContractVendorsPage() {
  const { user } = useAuth();
  const ok = user && user.role !== "partner_user" && (user.role === "super_admin" || (user.staff_permissions || []).includes("manage_contract_vendors"));
  return (
    <div className="min-h-screen bg-[#0B0F19] p-6 md:p-10 text-white">
      <div className="max-w-6xl mx-auto">
        <Link to="/admin" data-testid="cv-page-back" className="mono-body text-[11px] text-nex-chrome hover:text-nex-gold inline-flex items-center gap-2 mb-6"><ArrowLeft size={14} /> Back to Console</Link>
        <h1 className="serif-head text-4xl sm:text-5xl mb-8">Contract Vendors</h1>
        {ok ? <ContractVendorsTab /> : <div data-testid="cv-page-denied" className="p-6 border border-white/10 flex items-center gap-3 text-white/70"><Lock size={16} className="text-nex-gold" /> You need the “Manage contract vendors” permission.</div>}
      </div>
    </div>
  );
}
